<template>
  <ion-card mode="ios">
    <ion-card-header>
      <slide-x-left-transition :duration="700" :delay="200">
        <h6 v-show="show" class="text-up m-0">Program Lojalnościowy</h6>
      </slide-x-left-transition>
    </ion-card-header>
    <ion-card-content>
      <slide-y-up-transition :duration="500" :delay="200">
        <div v-show="show">
          <p>Program Lojalnościowy jest już dostępny w aplikacji mobilnej Portalu Gastro!</p>
        </div>
      </slide-y-up-transition>
      <slide-y-up-transition :duration="500" :delay="400">
        <div v-if="show">
          <ion-button mode="ios"
                      fill="outline"
                      size="small"
                      @click="goTo('LoyaltyIndex')"
                      class="btn">Zobacz szczegóły
          </ion-button>
        </div>
      </slide-y-up-transition>
    </ion-card-content>
  </ion-card>
</template>

<script>
  import goTo from '@/mixins/goto';

  export default {
    name: 'CardLoyaltyIndex',
    mixins: [goTo],
    data() {
      return {
        show: false,
      }
    },
    mounted(){
      this.show = true;
    }
  }
</script>

<style lang="scss" scoped>
  ion-card{
    margin: 15px 0;
  }
  ion-card-header{
    color: #fff;
    --background: #c09a53;
  }
  ion-card-content{
    padding: 0 20px 12px 20px;
    background: #c09a53;
    p{
      color: #fff !important;
    }
    .btn{
      margin-top: 10px;
      color: #fff !important;
      --border-color: #fff !important;
    }
  }
</style>